import StarIcon from '@mui/icons-material/Star';
import { useFeatures } from 'hooks/useFeatures';
import { Feature } from 'models/Feature';
import { useTranslation } from 'react-i18next';
import { GuardedComponent, GuardedComponentProps } from './GuardedComponent';

export interface FeatureComponentProps extends Omit<GuardedComponentProps, 'allowed' | 'message'> {
  feature: Feature;
  showFeatureIcon?: boolean;
}

export function FeatureComponent({
  feature,
  fallback,
  showFeatureIcon = true,
  mode,
  children,
}: FeatureComponentProps) {
  const { t } = useTranslation();
  const { checkFeature } = useFeatures();

  return (
    <GuardedComponent
      allowed={checkFeature(feature)}
      fallback={fallback}
      mode={mode}
      message={t('upgradePlanFeature', 'Upgrade your plan to access this feature')}
      endAdornment={
        showFeatureIcon ? (
          <StarIcon
            fontSize="small"
            color="primary"
            sx={{
              position: 'absolute',
              top: '50%',
              right: 16,
              transform: 'translateY(-50%)',
            }}
          />
        ) : null
      }
    >
      {children}
    </GuardedComponent>
  );
}
